import { ChartOptions } from 'chart.js';

// fermentation graph configuration
export const fermentationGraphOptions: ChartOptions<'scatter'> = {
  interaction: { mode: 'point' },
  layout: { padding: { top: 50 } },
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        padding: 20,
        // Filter out corridor & reference curve datasets from legend
        filter: (item) => item.text.includes('-') === false,
      },
      display: true,
      onClick: (_, legendItem, legend) => {
        const { datasetIndex } = legendItem;
        const { chart } = legend;

        if (chart === undefined || datasetIndex === undefined || !legend?.legendItems) {
          return;
        }

        const maxIndex = chart.data.datasets.length;
        const isVisible = chart.isDatasetVisible(datasetIndex);

        // Function to toggle dataset visibility if the index is valid
        const toggleDataset = (index: number, shouldShow: boolean) => {
          if (index < maxIndex) {
            shouldShow ? chart.show(index) : chart.hide(index);
          }
        };

        // Toggle visibility for all related datasets (corridor & reference curve)
        const indexes = chart.data.datasets
          .map((d, index) => (d.label?.includes(legendItem.text) ? index : -1))
          .filter((index) => index !== -1);

        for (const index of indexes) {
          toggleDataset(index, !isVisible);
        }

        // Toggle visibility for the current dataset
        toggleDataset(datasetIndex, !isVisible);

        // Update the chart to reflect changes
        chart.update();
      },
    },
    datalabels: {
      anchor: 'end',
      align: 'top',
      formatter: (point, context) => {
        if (
          (context.dataset as any)?.isReferenceCurve ||
          (context.dataset as any)?.isBoundary
        ) {
          return null;
        }
        return Number(point.y).toFixed(2);
      },
      font: { weight: 'bold' },
    },
    tooltip: {
      callbacks: {
        label(tooltipItem) {
          const y = tooltipItem.parsed.y;
          const value = Number.isInteger(y) ? y : y.toFixed(2);
          return `${value} ${tooltipItem.dataset.label}`;
        },
      },
    },
  },
  scales: {
    x: {
      type: 'linear',
      position: 'bottom',
      title: { display: false },
      ticks: {
        callback(_, index, __) {
          return index + 1;
        },
      },
    },
    y: { display: false, type: 'linear' },
    y1: { display: false, type: 'linear' },
  },
};
